export const state = {
  pageLoading: false,
  pageLoadingMessage: ''
}

export const getters = {}

export const mutations = {
  SET_PAGE_LOADING(state, loading) {
    state.pageLoading = loading
  },
  SET_PAGE_LOADING_MESSAGE(state, message) {
    state.pageLoadingMessage = message || ''
  }
}

export const actions = {
  setPageLoading({ commit }, { loading, message = '' }) {
    commit('SET_PAGE_LOADING_MESSAGE', message)
    commit('SET_PAGE_LOADING', loading)
  }
}
